var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleExcelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.50736 1.00736 0.5 2.25 0.5H7.6287C8.2254 0.5 8.79772 0.737053 9.21968 1.15901L11.341 3.28033C11.7629 3.70229 12 4.27459 12 4.87132V13.25C12 14.4927 10.9927 15.5 9.75 15.5H2.25C1.00736 15.5 0 14.4927 0 13.25V2.75ZM2.25 2C1.83579 2 1.5 2.33579 1.5 2.75V13.25C1.5 13.6642 1.83579 14 2.25 14H9.75C10.1642 14 10.5 13.6642 10.5 13.25V4.87132C10.5 4.67241 10.4209 4.48164 10.2803 4.34099L8.15903 2.21967C8.01832 2.07902 7.8276 2 7.6287 2H2.25Z",
    fill: "#27A668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 7.75C3.375 7.26675 3.76675 6.875 4.25 6.875L7.75 6.875C8.23326 6.875 8.625 7.26675 8.625 7.75L8.625 11.25C8.625 11.7333 8.23326 12.125 7.75 12.125L4.25 12.125C3.76675 12.125 3.375 11.7333 3.375 11.25L3.375 7.75ZM4.25 7.45833C4.08892 7.45833 3.95833 7.58892 3.95833 7.75L3.95833 11.25C3.95833 11.4111 4.08892 11.5417 4.25 11.5417L7.75 11.5417C7.91109 11.5417 8.04167 11.4111 8.04167 11.25L8.04167 7.75C8.04167 7.58892 7.91109 7.45833 7.75 7.45833L4.25 7.45833Z",
    fill: "#27A769"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 8.7417H8.60807M3.94141 10.2584H8.60807",
    stroke: "#27A769",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.16663L6 11.8333",
    stroke: "#27A769",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleExcelIcon);
export default __webpack_public_path__ + "static/media/littleExcelIcon.f9bb194030196fd65e88e508319079e6.svg";
export { ForwardRef as ReactComponent };